/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'identity.account-menu.account-details.manage-profile-link': 'Configurações da conta',
  'identity.account-menu.account-details.view-profile-tooltip': 'Perfil',
  'identity.account-menu.account-menu-content.log-out-button': 'Sair',
  'identity.account-menu.account-menu-content.switch-account-button': 'Trocar de conta',
  'identity.account-menu.account-menu-details.managed-account': 'Essa conta é gerenciada por <b>{managedBy}</b>',
  'identity.account-menu.account-menu-logged-out-state.log-in': 'Entrar',
  'identity.account-menu.account-menu-popup.skeleton.tooltip': 'Conta',
  'identity.account-menu.theme-switcher.dark.option': 'Escuro',
  'identity.account-menu.theme-switcher.light.option': 'Claro',
  'identity.account-menu.theme-switcher.match-browser.option': 'Corresponder ao navegador',
  'identity.account-menu.theme-switcher.theme-button': 'Tema',
};
